export default __webpack_public_path__ + "static/media/category2.a0b94b15.png";